module.exports = __webpack_public_path__ + "static/media/momoAge.97185f9a.png";